import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

let initialState = {
	name: null,
	nameError: false,
	email: null,
	emailError: false,
	mobile: null,
	mobileError: false,
	message: null,
	messageError: false,
};

const TarapacaContactSection = props => {
	let phoneNumberOne = '';
	let phoneNumberTwo = '';

	const [state, setState] = useState(initialState);

	if (
		(props.operator && props.operator.operator_name === 'barriaghisoni') ||
		(props.operator && props.operator.operator_name === 'combarbala') ||
		(props.operator && props.operator.operator_name === 'expresosantacruz')
	) {
		const temp = props.operator.phone_number.split('/');
		phoneNumberOne = temp[0];
		phoneNumberTwo = temp[1];
	}

	const onChange = (value, type) => {
		if (type == 'mobile') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (state.email && !CommonService.isEMailValid(state.email)) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.mobile) {
			setState({
				...state,
				mobileError: true,
				mobileErrorMessage: 'Ingresa tu número de teléfono',
			});
			errorCount++;
		} else if (!state.message) {
			setState({
				...state,
				messageError: true,
				messageErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};

	const onSubmit = () => {
		if (!validate()) {
			return;
		}
		// Ensure form submission only for 'tarapaca' or 'santamaria'
		if (props.operator && (props.operator.operator_name === 'tarapaca')) {

			// Operators that require the last_name field
			const operatorsRequiringLastName = []; // Add the operators' names in Array that require last_name

			let data = {
				name: state.name,
				email: state.email,
				phone_number: state.mobile,
				comments: state.message,
				operator_id: props.operator.operator_id,
				operator_name: props.operator.operator_name,
			};

			// Add last_name to data if the current operator requires it
			if (operatorsRequiringLastName.includes(props.operator.operator_name) && state.last_name) {
				data.last_name = state.last_name;
			}

			props.actions.apiCall({
				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
				.then(res => onContactInfoResponse(res), err => onContactInfoResponse(err));
		}
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		<div className="themes-theme-two-contact-section new-container">
			<div
				className="info d-flex align-items-center"
				style={{
					color:
						props.operator &&
							props.operator.color_codes &&
							props.operator.color_codes.tertiary_text_color
							? props.operator.color_codes.tertiary_text_color
							: '',
				}}
			>
				{(props.operator && props.operator.operator_name === 'kennybus') ||
					(props.operator && props.operator.operator_name === 'serenamar') ||
					(props.operator && props.operator.operator_name === 'tarapaca') ? (
					<div>
						{props.operator && props.operator.phone_number ? (
							<div className="info-item ">
								<img src={getIcons('Headphone', props.operator)} alt="" />
								<span className="info-text ">
									Teléfono: {props.operator && props.operator.phone_number}
								</span>
							</div>
						) : null}

						<div className="info-item ">
							<img src={getIcons('Whatsapp', props.operator)} alt="" />
							<span className="info-text">Whatsapp: +56 9 4915 6683</span>
						</div>

						{props.operator && props.operator.email ? (
							<div className="info-item ">
								<img src={getIcons('Email', props.operator)} alt="" />
								<span className="info-text">Email: {props.operator.email}</span>
							</div>
						) : null}
					</div>
				) : (props.operator && props.operator.operator_name === 'combarbala') ||
					(props.operator && props.operator.operator_name === 'expresosantacruz') ? (
					<div>
						{props.operator && props.operator.phone_number ? (
							<div className="info-item bold-text">
								<img src={getIcons('Headphone', props.operator)} alt="" />
								<span className="info-text ">Teléfono: {phoneNumberOne}</span>
							</div>
						) : null}

						<div className="info-item bold-text">
							<img src={getIcons('Whatsapp', props.operator)} alt="" />
							<span className="info-text">{phoneNumberTwo} </span>
						</div>

						{props.operator && props.operator.email ? (
							<div className="info-item bold-text">
								<img src={getIcons('Email', props.operator)} alt="" />
								<span className="info-text">Email: {props.operator.email}</span>
							</div>
						) : null}
					</div>
				) : props.operator && props.operator.operator_name === 'barriaghisoni' ? (
					<div>
						{props.operator && props.operator.phone_number ? (
							<div className="info-item bold-text">
								<img src={getIcons('Headphone', props.operator)} alt="" />
								<div className="info-text">Teléfono: &nbsp;</div>
								<div className="info-text pt-3">
									{phoneNumberOne} <br />
									{phoneNumberTwo}
								</div>
							</div>
						) : null}
						{props.operator && props.operator.address ? (
							<div
								className="info-item bold-text"
								style={{
									width: 280,
								}}
							>
								<img src={getIcons('address', props.operator)} alt="" />
								<span className="info-text">Casa matriz: {props.operator.address}</span>
							</div>
						) : null}
						{props.operator && props.operator.email ? (
							<div className="info-item bold-text">
								<img src={getIcons('Email', props.operator)} alt="" />
								<span className="info-text">Email: {props.operator.email}</span>
							</div>
						) : null}
					</div>
				) : props.operator && props.operator.operator_name === 'cormarbus' ? (
					<div>
						{props.operator && props.operator.address ? (
							<div className="info-item" style={{ alignItems: 'flex-start' }}>
								<img src={getIcons('office', props.operator)} alt="" />
								<span className="info-text" style={{ width: '65%' }}>
									<p className="bold-text" style={{ marginBottom: '10px' }}>
										Casa matriz:
									</p>
									<div style={{ lineHeight: '21px', marginBottom: '10px' }}>
										{props.operator && props.operator.address}
									</div>
									<p className="bold-text" style={{ marginBottom: '10px' }}>
										Para viajes especiales, cotizaciones y convenios con empresas, contactar al
										email:
									</p>
									{/* <div>cormarbus1@gmail.com</div>     */}
									<div>postulaciones@cormarbus1.cl</div>
								</span>
							</div>
						) : null}

						<div className="info-item" style={{ alignItems: 'flex-start' }}>
							<img src={getIcons('Headphone', props.operator)} alt="" />
							<span className="info-text">
								<p className="bold-text" style={{ marginBottom: '10px' }}>
									Atención ventas en línea:
								</p>
								<p style={{ marginBottom: '10px' }}>{props.operator && props.operator.email}</p>
								<p>{props.operator && props.operator.phone_number}</p>
							</span>
						</div>
					</div>
				) : props.operator && props.operator.operator_name === 'jetsur' ? (
					<div>
						{props.operator && props.operator.phone_number ? (
							<div className="info-item bold-text">
								<img src={getIcons('Headphone', props.operator)} alt="" />
								<span className="info-text ">
									Teléfono: {props.operator && props.operator.phone_number}
								</span>
							</div>
						) : null}

						{props.operator && props.operator.address ? (
							<div className="info-item bold-text">
								<img src={getIcons('address', props.operator)} alt="" />
								<span
									className="info-text"
									style={{ marginBottom: '10px', width: '80%', lineHeight: 1.3 }}
								>
									<span
										className="bold-text"
									// style={{ marginBottom: '10px', lineHeight: 1.3 }}
									>
										Casa matriz:
										{props.operator.address}
									</span>
								</span>
							</div>
						) : null}

						{props.operator && props.operator.email ? (
							<div className="info-item bold-text">
								<img src={getIcons('Email', props.operator)} alt="" />
								<span className="info-text">Email: {props.operator.email}</span>
							</div>
						) : null}
					</div>
				) : (
					<div>
						{props.operator && props.operator.address ? (
							<div className="info-item" style={{ alignItems: 'flex-start' }}>
								<img src={getIcons('office', props.operator)} alt="" />
								<span className="info-text">
									<p className="bold-text" style={{ marginBottom: '10px' }}>
										Casa matriz:
									</p>
									<div>{props.operator && props.operator.address}</div>
								</span>
							</div>
						) : null}


						{/* <div className={`info-item ${props.operator && props.operator.operator_name === "santamaria" ? 'santamaria-operator' : ''}`} style={{ alignItems: 'flex-start' }}>
  <img src={getIcons('Headphone', props.operator)} alt="" />
  <span className="info-text">
    {props.operator && props.operator.operator_name === "santamaria" ? (
      <div>
        <p className="bold-text santamaria-icon-text" style={{ marginBottom: '10px' }}>
          Teléfono: +56 2 3304 8632
        </p>
        <div className="info-item bold-text  santamaria-text">
            <img src={getIcons('Email', props.operator)} alt="" />
            <span className="info-text santamaria-icon-text">Email: {props.operator.email}</span>
          </div>
      </div>
    ) : (
      <div>
        <p className="bold-text" style={{ marginBottom: '10px' }}>
          Atención ventas en línea:
        </p>
        {props.operator && props.operator.email ? (
          <div className="info-item bold-text">
            <img src={getIcons('Email', props.operator)} alt="" />
            <span className="info-text">Email: {props.operator.email}</span>
          </div>
        ) : null}
        <p>{props.operator && props.operator.phone_number}</p>
      </div>
    )}
  </span>
</div> */}


						<div className={`info-item ${props.operator && (props.operator.operator_name === "santamaria" || props.operator.operator_name === "biaggini") ? props.operator.operator_name + '-operator' : ''}`} style={{ alignItems: 'flex-start' }}>
							<img src={getIcons('Headphone', props.operator)} alt="" />
							<span className="info-text">
								{props.operator && props.operator.operator_name === "santamaria" ? (
									<div>
										<p className="bold-text santamaria-icon-text" style={{ marginBottom: '10px' }}>
											Teléfono: +56 2 3304 8632
										</p>
										<div className="info-item bold-text santamaria-text">
											<img src={getIcons('Email', props.operator)} alt="" />
											<span className="info-text santamaria-icon-text">Email: {props.operator.email}</span>
										</div>
									</div>
								) : props.operator && props.operator.operator_name === "biaggini" ? (
									<div>
										<p className="bold-text biaggini-icon-text" style={{ marginBottom: '10px' }}>
											Teléfono: {props.operator.phone_number}
										</p>
										<div className="info-item bold-text biaggini-text">
											<img src={getIcons('Whatsapp', props.operator)} alt="" />
											<span className="info-text biaggini-icon-text">WhatsApp: +56 9 4915 6683</span>
										</div>
										<div className="info-item bold-text biaggini-text">
											<img src={getIcons('Email', props.operator)} alt="" />
											<span className="info-text biaggini-icon-text">Email: {props.operator.email}</span>
										</div>
									</div>
								) : (
									<div>
										<p className="bold-text" style={{ marginBottom: '10px' }}>
											Atención ventas en línea:
										</p>
										{props.operator && props.operator.email ? (
											<div className="info-item bold-text">
												<img src={getIcons('Email', props.operator)} alt="" />
												<span className="info-text">Email: {props.operator.email}</span>
											</div>
										) : null}
										<p>{props.operator && props.operator.phone_number}</p>
									</div>
								)}
							</span>
						</div>


					</div>
				)}
			</div>
			<div
				className="form"
				style={{
					background:
						props.operator && props.operator.operator_name === 'serenamar'
							? props.operator &&
							props.operator.color_codes &&
							props.operator.color_codes.primary_text_color &&
							props.operator.color_codes.primary_text_color
							: props.operator &&
							props.operator.color_codes &&
							props.operator.color_codes.secondary_color &&
							props.operator.color_codes.secondary_color,
					color:
						props.operator && props.operator.operator_name === 'barriaghisoni'
							? props.operator &&
								props.operator.color_codes &&
								props.operator.color_codes.tertiary_text_color
								? props.operator.color_codes.tertiary_text_color
								: ''
							: '',
				}}
			>
				<div className="form-inputs ">
					<div className="contact-input-item">
						<div className="contact-input-label  bold-text">Nombre</div>
						<KuposInput
							type="text"
							onChange={value => onChange(value, 'name')}
							value={state.name}
							error={state.nameError}
							errorMessage={state.nameErrorMessage}
						// placeholder="Nombre"
						/>
					</div>

					<div className="contact-input-item mx-2">
						<div className="contact-input-label bold-text ">Email</div>
						<KuposInput
							type="email"
							onChange={value => onChange(value, 'email')}
							value={state.email}
							error={state.emailError}
							errorMessage={state.emailErrorMessage}
						// placeholder="Email"
						/>
					</div>

					<div className="contact-input-item">
						<div className="contact-input-label  bold-text">Nº de contacto</div>
						<KuposInput
							type="number"
							onChange={value => onChange(value, 'mobile')}
							value={state.mobile}
							error={state.mobileError}
							errorMessage={state.mobileErrorMessage}
						//  placeholder="Nº de contacto"
						/>
					</div>
				</div>

				<div className="text-area-input mt-3">
					<div className="contact-input-label  bold-text">Mensaje</div>
					<textarea
						className="text-area "
						rows={4}
						onChange={event => onChange(event.target.value, 'message')}
						value={state.message}
					// placeholder="Mensaje"
					/>
					{state.messageError ? (
						<span className="error font8" style={{ color: 'red' }}>
							{state.messageErrorMessage}
						</span>
					) : null}
				</div>

				<div className="contact-button ">

					{props.operator && props.operator.operator_name === "combarbala" ? (
						<KuposButton
							operator={props.operator}
							className="button-padding grey-colour"
							onClick={() => {
								onSubmit();
							}}

						>

							ENVIAR
						</KuposButton>
					) : (<KuposButton
						operator={props.operator}
						className="button-padding"
						onClick={() => {
							onSubmit();
						}}

					>

						ENVIAR
					</KuposButton>
					)
					}
				</div>
			</div>

			<KuposErrorSuccessModal
				success={state.status == 200 ? true : false}
				showModal={state.showModal}
				onButtonClick={() => {
					setState({ showModal: false });
					window.location.reload();
				}}
				bodyText={state.responseMessage}
			/>
		</div >
	);
};

export default TarapacaContactSection;



// WEBPACK FOOTER //
// ./src/features/themes/Tarapaca/common/TarapacaContactSection.js